import service from '~api/compact-inside';

export default {
  // 1、内部字典项-接口
  getInsideCompactTypeList({ commit }, payload) {
    return service.apiGetInsideCategoryData(payload).then(res => res.data);
  },
  // 2、合同详情-对方公司列表查询
  getInsideCmpanyInfoList({ commit }, payload) {
    return service.apiGetInsideCmpanyInfo(payload).then(res => res.data);
  },
  // 3、合同详情-补充协议列表查询
  getInsideSupplementList({ commit }, payload) {
    return service.apiGetInsideSupplement(payload).then(res => res.data);
  },
  // 4、合同详情-续签协议列表查询
  getInsideContractRenewalList({ commit }, payload) {
    return service.apiGetInsideContractRenewal(payload).then(res => res.data);
  },
  // 5、合同详情-异常提报记录列表查询
  getInsideAbnormalReportRecordList({ commit }, payload) {
    return service.apiGetInsideAbnormalReportRecord(payload).then(res => res.data);
  },
  // 6、合同详情-调档记录列表查询
  getInsideShiftRecordList({ commit }, payload) {
    return service.apiGetInsideShiftRecord(payload).then(res => res.data);
  },
  // 7、合同详情-保证金/押金列表查询
  getInsideContractsBondList({ commit }, payload) {
    return service.apiGetInsideContractsBond(payload).then(res => res.data);
  },

  updateContractPerson({ commit }, payload) {
    return service.apiUpdateSalesman(payload).then(res => res.data);
  },

  deleteCrmcontract({ commit }, payload) {
    return service.deleteCrmcontract(payload).then(res => res.data);
  },
};
